export default "__VITE_ASSET__lco$IkKo__"